class TC_RegisterForm {
    constructor () {
        if ($('.is-special-page #register_form').length) {
            this.initEvents();
        }
    }

    initEvents () {
        let self = this;
        this.form = $('.is-special-page #register_form');
        this.usesChineseCaptcha = false;

        this.UI = {
            messages: {
                empty: this.form.find('.mod-calmradio-login-message-empty'),
                error: this.form.find('.mod-calmradio-login-message-error'),
                submitError: this.form.find('.mod-calmradio-login-message-submit-error')
            },
            buttons: {
                submit: this.form.find('.mod-calmradio-login-button'),
                loginWithFb: $('.mod-calmradio-login-with-fb'),
                loginWithGoogle: $('.mod-calmradio-login-with-google')
            },
            inputs: {
                firstName: this.form.find('input[name="first_name"]'),
                lastName: this.form.find('input[name="last_name"]'),
                email1: this.form.find('input[name="email1"]'),
                email2: this.form.find('input[name="email2"]'),
                password: this.form.find('input[name="password"]'),
                return: this.form.find('input[name="return"]')
            }
        };

        if (!this.UI.buttons.submit.hasClass('g-recaptcha')) {
            this.UI.buttons.submit.on('click', e => {
                e.preventDefault();
                this.prepareForm();
            });
        }

        if (this.form.find('.nog-captcha-container').length) {
            this.usesChineseCaptcha = true;

            this.UI.captcha = {
                wrapper: this.form.find('.nog-captcha-container'),
            };

            this.UI.captcha.input = this.UI.captcha.wrapper.find('input');
            this.UI.captcha.refreshButton = this.UI.captcha.wrapper.find('.captcha-refresh');
            this.UI.captcha.refreshButton.on('click', e => {
                e.preventDefault();
                this.refreshChineseCaptcha();
            });
        }

        let inputsToClearErrors = ['firstName', 'lastName', 'email1', 'email2', 'password'];

        for (let i = 0; i < inputsToClearErrors.length; i++) {
            this.UI.inputs[inputsToClearErrors[i]].on('keyup', e => {
                this.UI.inputs[inputsToClearErrors[i]].removeClass('is-invalid');
                this.checkIfAllIsFilled();
            });
        }

        this.UI.buttons.loginWithFb.on('click', e => {
            e.preventDefault();
            jfbc.login.provider('facebook');
        });

        this.UI.buttons.loginWithGoogle.on('click', e => {
            e.preventDefault();
            jfbc.login.provider('google');
        });

        if (this.usesChineseCaptcha) {
            this.UI.captcha.input.on('keyup', e => {
                this.UI.captcha.input.removeClass('is-invalid');
                this.checkIfAllIsFilled();
            });
        }
    }

    prepareForm () {
        if (this.isEmptyForm()) {
            if (!this.usesChineseCaptcha) {
                grecaptcha.reset();
            }

            return;
        }

        this.submitForm();
    }

    isEmptyForm () {
        let result = false;
        let inputs = ['firstName', 'lastName', 'email1', 'email2', 'password'];
        this.UI.messages.error.addClass('is-hidden');
        this.UI.messages.submitError.addClass('is-hidden');

        for (let i = 0; i < inputs.length; i++) {
            if (this.UI.inputs[inputs[i]].val() === '') {
                this.UI.messages.empty.removeClass('is-hidden');
                this.UI.inputs[inputs[i]].addClass('is-invalid');
                result = true;
            }
        }

        if (this.UI.inputs.email1.val() !== this.UI.inputs.email2.val()) {
            this.UI.messages.empty.removeClass('is-hidden');
            this.UI.inputs.email2.addClass('is-invalid');
            result = true;
        }

        if (this.usesChineseCaptcha) {
            if (
                this.UI.captcha.input.val() === '' ||
                this.UI.captcha.input.val() !== this.UI.captcha.wrapper.find('img').attr('data-captcha')
            ) {
                this.UI.messages.empty.removeClass('is-hidden');
                this.UI.captcha.input.addClass('is-invalid');
                result = true;
            }
        }

        return result;
    }

    checkIfAllIsFilled () {
        if (
            this.UI.inputs.firstName.val() !== '' &&
            this.UI.inputs.lastName.val() !== '' &&
            this.UI.inputs.email1.val() !== '' &&
            this.UI.inputs.email2.val() !== '' &&
            this.UI.inputs.password.val() !== '' &&
            (!this.usesChineseCaptcha || this.usesChineseCaptcha && this.UI.captcha.input.val() === '')
        ) {
            this.UI.messages.empty.addClass('is-hidden');
        }
    }

    formIsLoading () {
        this.UI.inputs.firstName.addClass('is-loading');
        this.UI.inputs.lastName.addClass('is-loading');
        this.UI.inputs.email1.addClass('is-loading');
        this.UI.inputs.email2.addClass('is-loading');
        this.UI.inputs.password.addClass('is-loading');
        this.UI.buttons.submit.addClass('is-loading');
        $('.mod-calmradio-login-social').addClass('is-loading');

        if (this.usesChineseCaptcha) {
            this.UI.captcha.input.addClass('is-loading');
        }
    }

    formIsLoaded () {
        this.UI.inputs.firstName.removeClass('is-loading');
        this.UI.inputs.lastName.removeClass('is-loading');
        this.UI.inputs.email1.removeClass('is-loading');
        this.UI.inputs.email2.removeClass('is-loading');
        this.UI.inputs.password.removeClass('is-loading');
        this.UI.buttons.submit.removeClass('is-loading');
        $('.mod-calmradio-login-social').removeClass('is-loading');

        if (this.usesChineseCaptcha) {
            this.UI.captcha.input.removeClass('is-loading');
        }
    }

    submitErrorOccurred (response = false) {
        this.UI.messages.submitError.removeClass('is-hidden');
    }

    handleResponse (response) {
        if (response.success === false) {
            if (response.message.indexOf('COM_CALMRADIO_USERNAME') > -1) {
                this.UI.messages.error.text(window.CSITE_LANGS.registerForm.errors.email);
            } else if (response.message.indexOf('COM_CALMRADIO_PASSWORD') > -1) {
                this.UI.messages.error.text(window.CSITE_LANGS.registerForm.errors.password);
            } else if (response.message.indexOf('COM_CALMRADIO_EMAIL') > -1) {
                this.UI.messages.error.text(window.CSITE_LANGS.registerForm.errors.wrongemail);
            } else {
                this.UI.messages.error.text(response.message);
            }

            this.UI.messages.error.removeClass('is-hidden');
        } else {
            
            // FB Pixel event
            if (typeof fbq !== 'undefined') {
                fbq('track', 'CompleteRegistration');
            }

            // Set Appsflyer event
            if (typeof window.AF !== 'undefined') {
                AF('pba', 'setCustomerUserId', response.user_id);
            }

            let wrapper = $('.mod-calmradio-login.is-register');
            wrapper.addClass('is-register-success');
            wrapper.children().css('display', 'none');
            wrapper.find('.mod-calmradio-login-success').css('display', 'block').removeClass('is-hidden');

            // Post-registration redirection
            setTimeout(function(){
                var $_GET = {};

                document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
                    function decode(s) {
                        return decodeURIComponent(s.split("+").join(" "));
                    }

                    $_GET[decode(arguments[1])] = decode(arguments[2]);
                });

                if (!!$_GET['return_url']) {
                    window.location.href = atob($_GET['return_url']);
                } else {
                    window.location = $('input[name="redirection"]', $('#register_form')).val();
                }
            }, 4000);
        }
    }

    submitForm () {
        let requestUrl = window.CSITE.baseUrl + 'en/register?option=com_ajax&module=calmradio_login&method=register&format=raw';
        this.form.find('input[name="name"]').val(this.UI.inputs.firstName.val() + ' ' + this.UI.inputs.lastName.val());

        $.ajax({
            url: requestUrl,
            beforeSend: () => {
                this.UI.messages.error.addClass('is-hidden');
                this.UI.messages.empty.addClass('is-hidden');
                this.UI.messages.submitError.addClass('is-hidden');
                this.formIsLoading();
            },
            data: this.form.serialize(),
            dataType: 'JSON',
            type: 'POST',
            success: response => {
                this.formIsLoaded();
                this.handleResponse(response);

                if (!this.usesChineseCaptcha) {
                    grecaptcha.reset();
                } else {
                    this.refreshChineseCaptcha();
                }
            },
            error: () => {
                this.formIsLoaded();
                this.submitErrorOccurred();

                if (!this.usesChineseCaptcha) {
                    grecaptcha.reset();
                } else {
                    this.refreshChineseCaptcha();
                }
            }
        });
    }

    refreshChineseCaptcha () {
        let container = this.form.find('.nog-captcha-container');
        container.addClass('loading');

        $.ajax({
          url: '?option=com_ajax&module=calmradio_login&method=initCaptcha&format=raw&t=' + new Date().getTime(),
          method: "GET",
          type: "JSON",
          success: response => {
            try {
              container.removeClass('loading');
              let data = JSON.parse(response);
              this.form.find('.captcha-img').prop('src', data.image_src).attr('data-captcha', data.code);
            } catch (_error) {}
          }
        });
    }

    handleCaptchaError () {
        grecaptcha.reset();
        alert(window.CSITE_LANGS.recaptchaMessage);
    }
}
